const TOLL_GASOLINE_KR = 4.95;
const TOLL_DIESEL_KR = 3.52;
const CO2_TOLL_GASOLINE_KR = 1.78;
const CO2_TOLL_DIESEL_KR = 2.05;
const TAX = 0.2; // 20%
const AVG_PREMIUM_GASOLINE = 0.8857;
const AVG_PREMIUM_DIESEL = 0; // TBA
const BARREL_SIZE_LITRES = 159;

export const calculatePetroleumPrice = (
    brentPrice,
    type,
    usdnok,
) => {
    const toll = getTollByType(type);
    const premium = getPremiumByType(type);
    const pricePerLitre = getPriceByLitre(brentPrice);

    const priceInKR = convertToKroner(pricePerLitre, usdnok);

    const petroPrice = priceInKR * (1 + premium) + toll;

    return (petroPrice * (1 + TAX));
};

const getTollByType = (type) => {
    if (type === 'DIESEL') {
        return TOLL_DIESEL_KR + CO2_TOLL_DIESEL_KR;
    }
    return TOLL_GASOLINE_KR + CO2_TOLL_GASOLINE_KR;
};

const getPremiumByType = (type) => {
    if (type === 'DIESEL') {
        return AVG_PREMIUM_DIESEL;
    }

    return AVG_PREMIUM_GASOLINE;
};

const getPriceByLitre = (brentPrice) => {
    return brentPrice / BARREL_SIZE_LITRES;
};

const convertToKroner = (pricePerLitre, usdnok) => {
    return pricePerLitre * usdnok;
};

export function percentOfRange(value, min, max) {
    return ((value - min) / (max - min)) * 100;
}